// DEPENDENCIES ---------------------------------------------------------------- //

// import React from 'react';

import { Theme, SvgIcon, useTheme } from '@mui/material';

// TYPES ---------------------------------------------------------------- //

interface TileIconUberProps {
  size?: number;
  useTileCorrections?: boolean;
}

// COMPONENT ---------------------------------------------------------------- //

const TileIconUber = ({ size = 40, useTileCorrections = true }: TileIconUberProps) => {
  const theme = useTheme();
  const clsx = useSxStyles(theme);

  return (
    <SvgIcon sx={useTileCorrections ? clsx.iconWithCorrections : clsx.icon} style={{ fontSize: `${size}px` }}>
      <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 250 86.86'>
        <path
          fill='currentColor'
          d='M77.24,85.35V.11H89.38V30.86c8.77-7.95,18.51-10.69,29.54-8.23A31,31,0,0,1,137.83,35,32.47,32.47,0,0,1,89.4,77.92v7.43H77.24Zm33.42-52.48c-11.41-.45-21.53,9.3-21.48,21.43a21.35,21.35,0,1,0,42.69.06C132,42.29,121.81,32.47,110.66,32.87Z'
        />
        <path
          fill='currentColor'
          d='M.15.09H12.87V2.47q0,25.29,0,50.58c0,6.14,1.79,11.71,6.13,16.23,10.41,10.84,29.52,6.56,34.16-7.74a30.17,30.17,0,0,0,1.48-9c.14-16.66.07-33.33.07-50V0c4.07,0,8,0,11.93,0,.28,0,.7.5.79.83a7.47,7.47,0,0,1,.06,1.71V82.86c0,2.49,0,2.49-2.5,2.49-2.68,0-5.37-.09-8,0-1.63.08-2.34-.33-2.18-2.1s0-3.42,0-5.47c-1.72,1.34-3.15,2.56-4.7,3.61-8,5.41-16.92,6.64-26.17,4.35C13.31,83.14,5.85,76.55,2.27,66.12A38.57,38.57,0,0,1,.14,54.34C-.09,36.72,0,19.09,0,1.46,0,1.09.1.71.15.09Z'
        />
        <path
          fill='currentColor'
          d='M212.29,58.29H161.42c1.68,7.9,5.82,13.57,13.15,16.19,10,3.58,18.5.69,25.42-7.63l8.82,6.48a32.7,32.7,0,0,1-12,10.07c-12.66,6.33-29.44,3.37-39.18-6.89C141.27,59.24,149,30,171.8,23.21c18-5.33,36.28,5.17,39.55,24.43C211.93,51.05,212,54.56,212.29,58.29Zm-13-9.9a18.74,18.74,0,0,0-19.13-15.68c-9.29.42-18.45,8.42-18.12,15.68Z'
        />
        <path
          fill='currentColor'
          d='M231.17,85.24H218.93V23.16h12v6.67l.42.29c4.58-6.65,11.14-8,18.64-7.4V33.89c-2.43.15-4.84.15-7.21.47-5.42.72-8.88,4-10.51,9a24.7,24.7,0,0,0-1.06,7.32c-.11,10.72-.05,21.44-.05,32.17Z'
        />
      </svg>
    </SvgIcon>
  );
};

// STYLES ---------------------------------------------------------------- //

const useSxStyles = (theme: Theme) => ({
  icon: {
    display: 'block',
    color: theme.palette.uber.main,
  },
  iconWithCorrections: {
    display: 'block',
    marginBottom: '-12px',
    fontSize: '40px',
    color: theme.palette.uber.main,
  },
});

// EXPORT ---------------------------------------------------------------- //

export default TileIconUber;
